type LoadingScreenProps = {
    message?: string;
};

export const LoadingScreen = ({message = 'Carregando...'}: LoadingScreenProps) => {
    return (
        <div className="loading-screen">
            <div className="loading-spinner" />
            <span className="loading-text">{message}</span>
        </div>
    );
};
